
import type { Article } from '../../../mocks/blog';

interface ArticleContentProps {
  article: Article;
}

const DEFAULT_CONTENT = `
<h2>前言</h2>
<p>這篇文章正在撰寫中，敬請期待完整內容。您可以透過後台管理頁面編輯並發布完整的文章內容。</p>
<h2>關於這個主題</h2>
<p>在當今快速發展的數位創作領域，每一個細節都至關重要。從概念的萌芽到最終成品的呈現，每個環節都需要精心設計與執行。</p>
<p>我們將在這篇文章中深入探討相關技術與創作思維，分享實際製作過程中的心得與洞察，希望能為同樣熱愛創作的你帶來啟發。</p>
<h2>核心要點</h2>
<ul>
  <li>深入理解創作流程的每個環節</li>
  <li>掌握關鍵技術與工具的使用方法</li>
  <li>建立屬於自己的創作方法論</li>
  <li>持續精進，追求卓越的視覺表現</li>
</ul>
<h2>結語</h2>
<p>創作是一條永無止境的探索之路。期待與你一同在這條路上前行，共同創造更多令人驚嘆的作品。</p>
`;

export default function ArticleContent({ article }: ArticleContentProps) {
  const htmlContent = article.content && article.content.trim().length > 0
    ? article.content
    : DEFAULT_CONTENT;

  return (
    <div
      className="article-body"
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}
